import React, { useMemo } from 'react'
import { Language } from '@graphics/gfx-common/dist/constants'
import { SingleEditionType } from '../../types/pack'
import { getTab } from '../../services/views'
import { splitFileNameExt } from '../../services/file'
import { CollapsePanel } from './CollapsePanel'
import { FileTreeIcon, FileTreeTypes } from './FileTreeIcon'
import { FileItem } from './FileItem'
import { StyledFileTitle, StyledArchiveLabel, StyledFileExt } from './styled'

interface IArchive {
  archiveName: string
  children: SingleEditionType[]
  id: string
  location: Location
  groupId: string
  packId: string
  editionId: string
  defaultLanguage: Language | ''
  errors: any
  genericEditionsErrors: Array<string | undefined>
}
export const Archive = ({
  archiveName,
  children,
  id,
  location,
  groupId,
  packId,
  editionId,
  defaultLanguage,
  errors,
  genericEditionsErrors,
}: IArchive) => {
  const { name, extension } = useMemo(() => splitFileNameExt(archiveName), [
    archiveName,
  ])
  return (
    <CollapsePanel
      id={id}
      shouldOpen
      summary={
        <StyledArchiveLabel>
          <FileTreeIcon mediaType={FileTreeTypes.archive} />
          <StyledFileTitle title={archiveName}>{name}</StyledFileTitle>
          {extension && <StyledFileExt>{`.${extension}`}</StyledFileExt>}
        </StyledArchiveLabel>
      }
    >
      {children.map((edition) => (
        <FileItem
          edition={edition}
          key={edition.id}
          href={`/group/${groupId}/pack/${packId}?edition=${
            edition.id
          }&tab=${getTab(location)}`}
          isActive={() => edition.id === editionId}
          isSecondLevel={true}
          defaultLanguage={defaultLanguage}
          error={
            errors.editions.includes(edition.editionIndex) &&
            genericEditionsErrors[edition.editionIndex]
          }
        />
      ))}
    </CollapsePanel>
  )
}
